import { getJSONFromHtml } from '../common';
import { ICountry, ICountryState } from './interfaces';

export const USA_ID = 271;
export const CANADA_ID = 309;

/**
 * get countries / states data
 */
export const getCountriesAndStates = () => {
    const data = getJSONFromHtml(document.getElementById('countries-and-states-data'));
    if(!data || !data.countries) return [];

    const countriesMap = new Map();
    data.countries.forEach((country: ICountry) => {
        country.states = country.states || [];
        countriesMap.set(country.countryID, country)
    });

    // add states to countries
    if(data.states){
        for(let i=0; i<data.states.length; i++){
            const state: ICountryState = data.states[i];
            if(!countriesMap.has(state.countryID)) continue;

            const country: ICountry = countriesMap.get(state.countryID);
            country.states.push(state);
        }
    }
    const countries: ICountry[] = Array.from(countriesMap.values());

    return countries;
};

export const getCountryByCode3 = (countries: ICountry[], countryCode: string) : ICountry|undefined => {
    return countries.find((country: ICountry) => country.countryThreeLetterCode.toString() === countryCode.toString());
};

export const getCountryByCode2 = (countries: ICountry[], countryCode: string) : ICountry|undefined => {
    return countries.find((country: ICountry) => country.country2Digit.toString() === countryCode.toString());
};

export const getCountryById = (countries: ICountry[], countryId: number) : ICountry|undefined => {
    return countries.find((country: ICountry) => country.countryID.toString() === countryId.toString());
};

export const getStateByCode = (country: ICountry|undefined, stateCode: string) => {
    return country?.states.find((state: ICountryState) => state.state2Digit.toString() === stateCode.toString());
};

export const getStateById = (country: ICountry|undefined, stateId: number) => {
    return country?.states.find((state: ICountryState) => state.stateID.toString() === stateId.toString());
};